import { LayoutConfig } from '../typings/shared.model';

export const LAYOUT_CONFIG_ADMIN: LayoutConfig = {
  sideNavConfig: {
    logoUrl: '/public/images/Logo.svg',
    menu: [
      {
        title: 'Dashboard',
        matIcon: 'dashboard',
        visible: true,
        step: 1,
        routerLink: 'dashboard',
        routerLinkActiveExact: true,
      },
      {
        title: 'Master Management',
        matIcon: 'person',
        visible: true,
        step: 2,
        routerLink: '',
        routerLinkActiveExact: true,
        subMenu: [
          {
            title: 'Role',
            // matIcon: 'person',
            visible: true,
            step: 2,
            routerLink: 'master-role',
            routerLinkActiveExact: true,
          },
          {
            title: 'Region',
            visible: true,
            step: 2,
            routerLink: 'master-area',
            routerLinkActiveExact: true,
          },
          {
            title: 'Country',
            visible: true,
            step: 2,
            routerLink: 'master-country',
            routerLinkActiveExact: true,
          },
          {
            title: 'user',
            visible: true,
            step: 2,
            routerLink: 'master-user',
            routerLinkActiveExact: true,
          },
          {
            title: 'Area Mapping',
            visible: true,
            step: 2,
            routerLink: 'area-mapping',
            routerLinkActiveExact: true,
          },
        ],
      },
      // {
      //   title: 'Store Management',
      //   matIcon: 'store',
      //   visible: true,
      //   step: 6,
      //   routerLink: 'store/store-list',
      //   routerLinkActiveExact: true,
      // },

      {
        title: 'Store Management',
        matIcon: 'person',
        visible: true,
        step: 3,
        routerLink: '',
        routerLinkActiveExact: true,
        subMenu: [
          {
            title: 'Channel',
            // matIcon: 'person',
            visible: true,
            step: 3,
            routerLink: 'channel',
            routerLinkActiveExact: true,
          },
          {
            title: 'Account',
            visible: true,
            step: 3,
            routerLink: 'account',
            routerLinkActiveExact: true,
          },
          {
            title: 'Store',
            visible: true,
            step: 3,
            routerLink: 'store/store-list',
            routerLinkActiveExact: true,
          },
        ],
      },

      {
        title: 'Survey Management',
        matIcon: 'lists',
        visible: true,
        step: 5,
        routerLink: 'survey',
        routerLinkActiveExact: true,
      },
      {
        title: 'Product Management',
        matIcon: 'lists',
        visible: true,
        step: 6,
        routerLink: '',
        routerLinkActiveExact: true,
        subMenu: [
          {
            title: 'Brand',
            // matIcon: 'person',
            visible: true,
            step: 6,
            routerLink: 'brand',
            routerLinkActiveExact: true,
          },
          {
            title: 'Product Line',
            // matIcon: 'person',
            visible: true,
            step: 6,
            routerLink: 'product',
            routerLinkActiveExact: true,
          },
          {
            title: 'Category',
            // matIcon: 'person',
            visible: true,
            step: 6,
            routerLink: 'category',
            routerLinkActiveExact: true,
          },
          {
            title: 'Sub Category',
            // matIcon: 'person',
            visible: true,
            step: 6,
            routerLink: 'sub-category',
            routerLinkActiveExact: true,
          },
          {
            title: 'Product Master',
            // matIcon: 'person',
            visible: true,
            step: 6,
            routerLink: 'product-line',
            routerLinkActiveExact: true,
          },
        ],
      }
      // {
      //   title: 'User Management',
      //   matIcon: 'person',
      //   visible: true,
      //   step: 2,
      //   routerLink: '',
      //   routerLinkActiveExact: true,
      //   subMenu: [
      //     {
      //       title: 'Master List',
      //       // matIcon: 'person',
      //       visible: true,
      //       step: 2,
      //       routerLink: 'master-list',
      //       routerLinkActiveExact: true,
      //     },
      //     {
      //       title: 'Admin List',

      //       visible: true,
      //       step: 2,
      //       routerLink: 'admin-list',
      //       routerLinkActiveExact: true,
      //     },
      //     {
      //       title: 'Regional Admin',

      //       visible: true,
      //       step: 2,
      //       routerLink: 'regional-page',
      //       routerLinkActiveExact: true,
      //     },
      //     {
      //       title: 'Country PIC',

      //       visible: true,
      //       step: 2,
      //       routerLink: 'add-country-pic',
      //       routerLinkActiveExact: true,
      //     },
      //     {
      //       title: 'Mobile User',

      //       visible: true,
      //       step: 2,
      //       routerLink: 'user-list',
      //       routerLinkActiveExact: true,
      //     },
      //   ],
      // },

      // {
      //   title: 'Journey Plan',
      //   matIcon: 'lists',
      //   visible: true,
      //   step: 6,
      //   routerLink: 'journey-plan',
      //   routerLinkActiveExact: true,
      // },
      // {
      //   title: 'Settings',
      //   matIcon: 'settings',
      //   routerLink: 'setting-page',
      //   visible: true,
      //   step: 7,
      //   routerLinkActiveExact: true,
      // },
    ],
  },
};
